<template>
	<v-dialog v-model="showDialog" width="800px">
		<v-card>
			<v-app-bar dense dark flat color="primary">
				<v-app-bar-title class="color-white">見積内容確認</v-app-bar-title>
				<v-spacer />
				<v-btn icon dark @click="showDialog = false" color="white">
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</v-app-bar>

			<div class="pa-2">
				<v-row justify="end" no-gutters>
					<v-btn color="secondary" @click="openMatterDialog"> 案件情報確認 </v-btn>
				</v-row>
				<v-form ref="form" v-model="valid" class="mt-4">
					<table width="100%">
						<!-- TODO -->
						<ConfirmRecord :name="'見積承認日'" :value="'2023/05/01'" />
						<ConfirmRecord :name="'見積提出日'" :value="'2023/05/03'" />
						<ConfirmRecord :name="'見積先'" :value="'西田鉄工(株)'" />
						<ConfirmRecord :name="'客先照会番号'" :value="'12345678'" />
						<ConfirmRecord :name="'客先照会日付'" :value="'2020/01/01'" />
						<ConfirmRecord :name="'納品場所'" :value="'山梨県飽海郡遊佐町東口道上'" />
						<ConfirmRecord :name="'納期'" :value="'2023/09/01'" />
						<ConfirmRecord :name="'支払い条件'" :value="'従来通り'" />
						<ConfirmRecord :name="'見積有効期限'" :value="'2023/06/01'" />
						<ConfirmRecord :name="'客先名'" :value="'(株)湊製作所'" />
						<ConfirmRecord :name="'納入先名'" :value="'西田鉄工(株)'" />
						<ConfirmRecord :name="'工事名'" :value="'-'" />
						<ConfirmRecord :name="'品名'" :value="'ゴム伸縮継手'" />
						<ConfirmRecord :name="'見積条件'" :value="'※ 見積仕様条件は、別紙明細書通りとします。'" />
						<ConfirmRecord :name="'添付資料'" :value="''">
							<template v-slot:value>
								<!-- TODO ファイルを並べる -->
								<a> ファイル.pdf </a>
							</template>
						</ConfirmRecord>
						<template v-for="(matter_product, i) in matter.matter_products">
							<ConfirmRecord
								:name="'品名'"
								:value="'ゴム伸縮継手'"
								:colspan="1"
								:index="i+1"
								:rowspan="6"
								:key="`name-${matter_product.id}`"
							/>
							<ConfirmRecord
								:name="'寸法'"
								:value="'1800A × 900L'"
								:key="`measure-${matter_product.id}`"
								:colspan="1"
							/>
							<ConfirmRecord
								:name="'数量'"
								:value="'3'"
								:key="`quantity-${matter_product.id}`"
								:colspan="1"
							/>
							<ConfirmRecord
								:name="'単位'"
								:value="'基'"
								:key="`unit-${matter_product.id}`"
								:colspan="1"
							/>
							<ConfirmRecord
								:name="'単価'"
								:value="'1,880,000'"
								:key="`price-${matter_product.id}`"
								:colspan="1"
							/>
							<ConfirmRecord
								:name="'適応(型式)'"
								:value="'DMⅡ100M'"
								:key="`model-${matter_product.id}`"
								:colspan="1"
							/>
						</template>
					</table>
				</v-form>
			</div>

			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn color="primary" text @click="showDialog = false"> 戻る </v-btn>
				<v-btn :disabled="!valid" color="primary" text @click="$emit('submit-form')">
					{{ actionText }}
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import common from "../../../helper/common"
import ConfirmRecord from "../../shared/ConfirmRecord.vue"
export default {
	components: {
		ConfirmRecord,
	},
	props: {
		quotation: {
			type: Object,
			default: () => ({}),
		},
		dialog: {
			type: Boolean,
			required: false,
		},
		matter: {
			type: Object,
			required: false,
		},
		actionText: {
			type: String,
			required: false,
			default: "見積を作成して、確認を依頼する",
		},
	},
	data() {
		return {
			headers: [],
			valid: false,
			common,
		}
	},
	methods: {
		openMatterDialog() {},
	},
	computed: {
		showDialog: {
			get() {
				return this.dialog
			},
			set(value) {
				this.$emit("update:dialog", value)
			},
		},
	},
}
</script>